<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<template lang="pug">

  div

    div.c-auth-page__head
      h1 {{ $t('h1') }}

    div
      p Происходит переход в личный кабинет
      p Пожалуйста, подождите...

</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('registration', [
      'email',
      'firstName',
      'lastName',
      'cookie',
      'returnUrl',
      'phoneNumberE164',
    ]),
  },

  validations: {
    cookie: { required },
    returnUrl: { required },
  },

  mounted() {
    window.location = this.returnUrl;
  },
};
</script>
